import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=ce8f4b36&scoped=true&"
import script from "./FileModal.vue?vue&type=script&lang=js&"
export * from "./FileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8f4b36",
  null
  
)

export default component.exports